export default "__VITE_ASSET__9cd28d4d__"